/**
 * Le palier d'une NOTION — chantier « manuel vivant », Φ-MV-5 (MV-TUT-03).
 *
 * Jumeau de `PalierMaitrise`, pour l'autre grain (AD-MV-4) : une notion du
 * chapitre a QUATRE paliers (« Nouveau », « En progression », « À consolider »,
 * « Acquis »), un savoir du programme en a cinq. Même règle : le MOT est la
 * donnée, il vient du serveur (`libellePalier`) ; les crans ne font que le
 * situer, sont `aria-hidden`, et ne s'affichent jamais seuls ni en chiffre.
 *
 * Pas de teinte d'attention ici : « à surveiller » est une lecture du tuteur
 * sur l'ensemble (la tendance, l'erreur qui revient), pas une couleur de palier.
 */
import type { PalierNotion } from '@silex/shared';

import { NB_CRANS_NOTION, cransDuPalier } from '../lib/manuel-tuteur-format';

export function CransNotion({
  palier,
  libelle,
}: {
  readonly palier: PalierNotion;
  readonly libelle: string;
}) {
  const rang = cransDuPalier(palier);
  return (
    <span className="palier">
      <span className="pal-steps" aria-hidden="true">
        {Array.from({ length: NB_CRANS_NOTION }, (_, i) => (
          <i key={i} className={i < rang ? 'on' : undefined} />
        ))}
      </span>
      <span className="pal-lbl">{libelle}</span>
    </span>
  );
}
